import { ArrayUtils } from '@shopping/common'
import { StateKey } from 'common/utils/flipState'
import { EventListSearchParam, EventParam, EventsState } from 'common/types/entities/event'
import { fetchSpecialEvents } from 'common/services/specialEvent'
import { fetchNewsBySubVerticalAtEvent } from 'common/services/news'
import history from 'common/history'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { SubVertical } from 'common/constants'

const initialState: EventsState = {
  events: [],
  hasMore: false,
  pageCount: 0,
  page: 0,
  cacheParam: null,
}

const FETCH_COMPOSITE = 'event/event/FETCH_COMPOSITE'
const FETCH = 'event/event/FETCH'

export const fetchCompositeEvents = (curState: StateKey, eventListSearchParam: EventListSearchParam) => async (
  dispatch,
  getState,
) => {
  const cacheParam = createCacheParam(FETCH_COMPOSITE, 'fetchCompositeEvents', { curState, eventListSearchParam })

  const { eventParam, newsParam } = eventListSearchParam
  const params = eventParam || newsParam
  const restoredEvents = getEventsFromHistoryState()
  if (restoredEvents) {
    dispatch({
      curState,
      cacheParam,
      state: restoredEvents,
      type: FETCH_COMPOSITE,
    })
    history.location.state.eventsState = null
    return
  }

  if (isCacheHit(getState().events[curState], cacheParam)) {
    return
  }

  const [specialEvents = initialState, news] = await Promise.all([
    fetchSpecialEvents(eventParam),
    newsParam && fetchNewsBySubVerticalAtEvent(newsParam),
  ])

  let events = []
  if (eventParam && SubVertical.TRADITIONAL_ALCOHOL === eventParam.subVertical) {
    news.articles.forEach((news, index) => {
      events.push(news)

      if (specialEvents) {
        if (index % 3 === 2) {
          const event = specialEvents.events.splice(0, 1).pop()
          event && events.push(event)
        }
      }
    })

    if (
      ArrayUtils.size(news.articles) < ((newsParam && newsParam.pageSize) || eventParam.pageSize) &&
      specialEvents &&
      ArrayUtils.isNotEmpty(specialEvents.events)
    ) {
      events = [...events, ...specialEvents.events]
    }
  } else {
    specialEvents.events.forEach((event, index) => {
      events.push(event)

      if (news) {
        if (index % 2 === 1) {
          const tempNews = news.articles.splice(0, 1).pop()
          tempNews && events.push(tempNews)
        }
      }
    })

    if (
      ArrayUtils.size(specialEvents.events) < ((eventParam && eventParam.pageSize) || newsParam.pageSize) &&
      news &&
      ArrayUtils.isNotEmpty(news.articles)
    ) {
      events = [...events, ...news.articles]
    }
  }

  const eventsState = getState().events[curState]
  events = params.page === 1 ? events : [...eventsState.events, ...events]
  const { hasMore } = specialEvents
  const branchNewsHasMore = (news && news.hasMore) || false

  const state = {
    events,
    hasMore: hasMore || branchNewsHasMore,
    page: params.page,
    inquiryPageSize: params.pageSize,
    restoredByHistory: false,
  }

  dispatch({
    curState,
    state,
    cacheParam,
    type: FETCH_COMPOSITE,
  })
}

const getEventsFromHistoryState = () => {
  if (history.location && history.location.state && history.location.state.eventsState) {
    return {
      ...history.location.state.eventsState,
    }
  }
}

export const fetchEvents = (curState: StateKey, eventParam: EventParam) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchEvents', { curState, eventParam })

  if (isCacheHit(getState().events[curState], cacheParam)) {
    return
  }

  const specialEvents = (await fetchSpecialEvents(eventParam)) || initialState

  const eventsState = getState().events[curState]
  const events = eventParam.page === 1 ? specialEvents.events : [...eventsState.events, ...specialEvents.events]

  const state = {
    events,
    page: eventParam.page,
    inquiryPageSize: eventParam.pageSize,
    restoredByHistory: false,
    totalCount: specialEvents.totalCount,
  }

  dispatch({
    curState,
    state,
    cacheParam,
    type: FETCH,
  })
}

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
    case FETCH_COMPOSITE:
      return {
        ...action.state,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default eventReducer
